import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleSelector = ({ selectedRole, onRoleChange }) => {
  const roles = [
    {
      value: 'customer',
      label: 'Customer',
      icon: 'ShoppingBag',
      description: 'Order delicious home-cooked meals',
      features: ['Browse local kitchens', 'Customize orders', 'Track deliveries']
    },
    {
      value: 'supplier',
      label: 'Supplier',
      icon: 'ChefHat',
      description: 'Start your cloud kitchen business',
      features: ['Create your menu', 'Manage orders', 'Grow your business']
    }
  ];

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-caption font-semibold mb-3">
          I want to join as <span className="text-accent">*</span>
        </label>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {roles?.map((role) => (
            <button
              key={role?.value}
              type="button"
              onClick={() => onRoleChange(role?.value)}
              className={`relative p-6 rounded-xl border-2 transition-smooth text-left ${
                selectedRole === role?.value
                  ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50 bg-card'
              }`}
            >
              {selectedRole === role?.value && (
                <div className="absolute top-4 right-4 w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                  <Icon name="Check" size={16} color="var(--color-primary-foreground)" />
                </div>
              )}
              <div className="flex items-start gap-4 mb-4">
                <div
                  className={`w-12 h-12 rounded-lg flex items-center justify-center transition-smooth ${
                    selectedRole === role?.value
                      ? 'bg-primary' :'bg-muted'
                  }`}
                >
                  <Icon
                    name={role?.icon}
                    size={24}
                    color={selectedRole === role?.value ? 'var(--color-primary-foreground)' : 'var(--color-foreground)'}
                  />
                </div>
                <div className="flex-1">
                  <h3 className="font-heading font-semibold text-lg mb-1">{role?.label}</h3>
                  <p className="text-sm text-muted-foreground">{role?.description}</p>
                </div>
              </div>
              <ul className="space-y-2">
                {role?.features?.map((feature, index) => (
                  <li key={index} className="flex items-center gap-2 text-sm">
                    <Icon
                      name="Check"
                      size={16}
                      color={selectedRole === role?.value ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
                    />
                    <span className={selectedRole === role?.value ? 'text-foreground' : 'text-muted-foreground'}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RoleSelector;